module.exports = __webpack_public_path__ + "static/media/error.b25331c1.png";